export enum ObjectUserData {
	PATH = 'path',
	LOW_RES_SOFT_BODY_MESH = 'lowResSoftBodyMesh',
}
